export default "__VITE_ASSET__BtBD2Ehr__"